<template>
  <div>
    <div class="bz-refine-note">
      <i class="material-icons" style="font-size:15px;line-height:1;">filter_alt</i>
      All filters are optional and set to Any — the matching count on the right updates instantly with every change.
    </div>
    <div class="bz-filtergrid">
      <div class="bz-filter" :class="{ active: f.revFrom !== null || f.revTo !== null }">
        <div class="bz-filter-h">
          <i class="material-icons" style="font-size:15px;line-height:1;">payments</i>Estimated revenue
          <button v-if="f.revFrom !== null || f.revTo !== null" class="reset" type="button" @click="patch({ revFrom: null, revTo: null }, 'revenue')">Reset</button>
        </div>
        <div class="bz-filter-row">
          <select class="bz-select" :value="sel(f.revFrom)" @change="patch({ revFrom: idx($event), revTo: clampTo(idx($event), f.revTo) }, 'revenue')">
            <option value="">From (any)</option>
            <option v-for="(b, i) in revBands" :key="'rf' + i" :value="i">{{ b }}</option>
          </select>
          <span style="color:var(--bzc-faint);">—</span>
          <select class="bz-select" :value="sel(f.revTo)" @change="patch({ revTo: clampTo(f.revFrom, idx($event)) }, 'revenue')">
            <option value="">To (any)</option>
            <option v-for="(b, i) in revBands" :key="'rt' + i" :value="i">{{ b }}</option>
          </select>
        </div>
      </div>

      <div class="bz-filter" :class="{ active: f.valFrom !== null || f.valTo !== null }">
        <div class="bz-filter-h">
          <i class="material-icons" style="font-size:15px;line-height:1;">sell</i>Estimated business value
          <button v-if="f.valFrom !== null || f.valTo !== null" class="reset" type="button" @click="patch({ valFrom: null, valTo: null }, 'value')">Reset</button>
        </div>
        <div class="bz-filter-row">
          <select class="bz-select" :value="sel(f.valFrom)" @change="patch({ valFrom: idx($event), valTo: clampTo(idx($event), f.valTo) }, 'value')">
            <option value="">From (any)</option>
            <option v-for="(b, i) in valBands" :key="'vf' + i" :value="i">{{ b }}</option>
          </select>
          <span style="color:var(--bzc-faint);">—</span>
          <select class="bz-select" :value="sel(f.valTo)" @change="patch({ valTo: clampTo(f.valFrom, idx($event)) }, 'value')">
            <option value="">To (any)</option>
            <option v-for="(b, i) in valBands" :key="'vt' + i" :value="i">{{ b }}</option>
          </select>
        </div>
      </div>

      <div class="bz-filter" :class="{ active: f.empFrom !== null || f.empTo !== null }">
        <div class="bz-filter-h">
          <i class="material-icons" style="font-size:15px;line-height:1;">groups</i>Employee count
          <button v-if="f.empFrom !== null || f.empTo !== null" class="reset" type="button" @click="patch({ empFrom: null, empTo: null }, 'employees')">Reset</button>
        </div>
        <div class="bz-filter-row">
          <select class="bz-select" :value="sel(f.empFrom)" @change="patch({ empFrom: idx($event), empTo: clampTo(idx($event), f.empTo) }, 'employees')">
            <option value="">From (any)</option>
            <option v-for="(b, i) in empBands" :key="'ef' + i" :value="i">{{ b }}</option>
          </select>
          <span style="color:var(--bzc-faint);">—</span>
          <select class="bz-select" :value="sel(f.empTo)" @change="patch({ empTo: clampTo(f.empFrom, idx($event)) }, 'employees')">
            <option value="">To (any)</option>
            <option v-for="(b, i) in empBands" :key="'et' + i" :value="i">{{ b }}</option>
          </select>
        </div>
      </div>

      <div class="bz-filter" :class="{ active: f.years !== 'any' }">
        <div class="bz-filter-h">
          <i class="material-icons" style="font-size:15px;line-height:1;">history</i>Years in business
          <button v-if="f.years !== 'any'" class="reset" type="button" @click="patch({ years: 'any' }, 'years')">Reset</button>
        </div>
        <select class="bz-select" :value="f.years" @change="patch({ years: $event.target.value }, 'years')">
          <option v-for="y in yearsOpts" :key="y.id" :value="y.id">{{ y.label }}</option>
        </select>
      </div>

      <div class="bz-filter" :class="{ active: f.phone }">
        <div class="bz-filter-h">
          <i class="material-icons" style="font-size:15px;line-height:1;">contact_mail</i>Contacts
          <button v-if="f.phone" class="reset" type="button" @click="patch({ phone: false }, 'contacts')">Reset</button>
        </div>
        <label class="bz-check">
          <input type="checkbox" :checked="f.phone" @change="patch({ phone: $event.target.checked }, 'contacts')" />
          Has direct phone
        </label>
      </div>

      <div class="bz-filter" :class="{ active: f.franchise !== 'any' }">
        <div class="bz-filter-h">
          <i class="material-icons" style="font-size:15px;line-height:1;">storefront</i>Franchise
          <button v-if="f.franchise !== 'any'" class="reset" type="button" @click="patch({ franchise: 'any' }, 'franchise')">Reset</button>
        </div>
        <div class="bz-seg">
          <button type="button" :class="{ on: f.franchise === 'any' }" @click="patch({ franchise: 'any' }, 'franchise')">Any</button>
          <button type="button" :class="{ on: f.franchise === 'only' }" @click="patch({ franchise: 'only' }, 'franchise')">Only franchises</button>
          <button type="button" :class="{ on: f.franchise === 'exclude' }" @click="patch({ franchise: 'exclude' }, 'franchise')">Exclude</button>
        </div>
      </div>

      <div class="bz-filter" :class="{ active: f.web !== 'any' }">
        <div class="bz-filter-h">
          <i class="material-icons" style="font-size:15px;line-height:1;">language</i>Web presence
          <button v-if="f.web !== 'any'" class="reset" type="button" @click="patch({ web: 'any' }, 'web')">Reset</button>
        </div>
        <div class="bz-seg">
          <button type="button" :class="{ on: f.web === 'any' }" @click="patch({ web: 'any' }, 'web')">Any</button>
          <button type="button" :class="{ on: f.web === 'has' }" @click="patch({ web: 'has' }, 'web')">Has website</button>
        </div>
      </div>

      <div class="bz-filter" :class="{ active: f.social !== 'any' }">
        <div class="bz-filter-h">
          <i class="material-icons" style="font-size:15px;line-height:1;">campaign</i>Social presence
          <button v-if="f.social !== 'any'" class="reset" type="button" @click="patch({ social: 'any' }, 'social')">Reset</button>
        </div>
        <div class="bz-seg">
          <button type="button" :class="{ on: f.social === 'any' }" @click="patch({ social: 'any' }, 'social')">Any</button>
          <button type="button" :class="{ on: f.social === 'active' }" @click="patch({ social: 'active' }, 'social')">Active social</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// All refine filters visible at once, each optional + resettable. Band indexes
// map to dollar/employee bounds in ProspectPage when building the count params.
// (No "has email" filter — Bizminer has no per-location email data, so it is
// intentionally excluded from the prospect filters permanently, not deferred.)
// Revenue/value bands MUST mirror the backend's band tables, which are keyed by BAND INDEX
// (not dollars): IMRController's $arraySalesValuesFrom/$arraySalesValuesTo for revenue and
// ListController::getAMVKey for value — both use the same 2..15 scheme, and both are what the
// classic selector sends. The *_IDX arrays map a dropdown position to that backend index.
// Index 1 means "any/unbounded" (from=0, to=999999999999999). Note the backend defines no
// 13/14 — it jumps $20m–$24.99m (12) straight to $40m–$49.99m (15); mirrored here so every
// option the user can pick is one the backend can actually resolve.
export const REV_BANDS = ['$1–$499k', '$500k–$999k', '$1m–$1.99m', '$2m–$2.99m', '$3m–$3.99m', '$4m–$4.99m',
  '$5m–$7.49m', '$7.5m–$9.99m', '$10m–$14.99m', '$15m–$19.99m', '$20m–$24.99m', '$40m–$49.99m'];
export const REV_IDX = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15];
export const VAL_BANDS = ['$1–$499k', '$500k–$999k', '$1m–$1.99m', '$2m–$2.99m', '$3m–$3.99m', '$4m–$4.99m',
  '$5m–$7.49m', '$7.5m–$9.99m', '$10m–$14.99m', '$15m–$19.99m', '$20m–$24.99m', '$40m–$49.99m'];
export const VAL_IDX = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15];
export const EMP_BANDS = ['1–4', '5–9', '10–19', '20–49', '50–99', '100–249', '250+'];
export const YEARS_OPTS = [
  { id: 'any', label: 'Any' }, { id: '1', label: '1+ years' }, { id: '3', label: '3+ years' },
  { id: '5', label: '5+ years' }, { id: '10', label: '10+ years' }, { id: '20', label: '20+ years' },
];
export const DEFAULT_FILTERS = {
  revFrom: null, revTo: null, valFrom: null, valTo: null, empFrom: null, empTo: null,
  years: 'any', phone: false, franchise: 'any', web: 'any', social: 'any',
};

export default {
  name: 'refine-step',
  props: {
    f: { type: Object, required: true },
  },
  data() {
    return { revBands: REV_BANDS, valBands: VAL_BANDS, empBands: EMP_BANDS, yearsOpts: YEARS_OPTS };
  },
  methods: {
    sel(v) {
      return v === null ? '' : v;
    },
    idx(e) {
      return e.target.value === '' ? null : Number(e.target.value);
    },
    clampTo(from, to) {
      return from !== null && to !== null && to < from ? from : to;
    },
    patch(p, filterName) {
      this.$emit('change', { patch: p, filter: filterName });
    },
  },
};
</script>
